import { render, staticRenderFns } from "./RecommendedUpgrade.vue?vue&type=template&id=737c1c86"
import script from "./RecommendedUpgrade.vue?vue&type=script&lang=js"
export * from "./RecommendedUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports